var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"desc shop"},[_c('el-row',[_c('p',[_vm._v("欣源商贸")])]),_c('el-row',[_c('el-col',[_c('img',{attrs:{"src":require("@/assets/images/projects/shop/xyshop.jpg"),"alt":""}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }